import clsx from "clsx";

import { confidenceWording } from "../lib/format";

export type ConfidenceNoteProps = {
  /** 0..1 */
  confidence: number | null;
  identificationNotes?: string | null;
  className?: string;
  /** Compact form for feed cards. */
  compact?: boolean;
};

/**
 * How sure the identification is, in words first and numbers second. A hedge is
 * more useful than false precision, so tentative determinations say so plainly
 * rather than hiding behind a percentage.
 */
export function ConfidenceNote({
  confidence,
  identificationNotes,
  className,
  compact = false,
}: ConfidenceNoteProps) {
  const wording = confidenceWording(confidence);
  const notes = identificationNotes?.trim();

  if (!wording && !notes) return null;

  if (compact) {
    if (!wording) return null;
    return (
      <span className={clsx("field-label-tight", wording.tentative ? "text-rust" : "text-ink-soft", className)}>
        {wording.label}
        <span className="ml-1 opacity-60">{wording.percent}%</span>
      </span>
    );
  }

  return (
    <div className={clsx("border-t border-rule pt-3", className)}>
      <p className="field-label">Determination</p>
      {wording ? (
        <p className="mt-1.5 font-prose text-[0.95rem] leading-snug text-ink">
          <span className={clsx("font-medium", wording.tentative ? "text-rust" : "text-ink")}>
            {wording.label}.
          </span>{" "}
          <span className="text-ink-soft">{wording.sentence}</span>
          <span className="ml-1 font-label text-xs tracking-wide text-ink-soft opacity-70">
            ({wording.percent}%)
          </span>
        </p>
      ) : null}
      {notes ? (
        <p className="mt-2 font-prose text-[0.95rem] leading-snug text-ink-soft italic">{notes}</p>
      ) : null}
    </div>
  );
}
